/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Contact_DescriptionInputs */

const he_help_contact_description = /** @type {(inputs: Help_Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צריכים עזרה? פנו לצוות התמיכה שלנו.`)
};

const en_help_contact_description = /** @type {(inputs: Help_Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need assistance? Reach out to our support team.`)
};

/**
* | output |
* | --- |
* | "Need assistance? Reach out to our support team." |
*
* @param {Help_Contact_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const help_contact_description = /** @type {((inputs?: Help_Contact_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Contact_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_help_contact_description(inputs)
	return en_help_contact_description(inputs)
});